import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { WarmupDataStorage } from './DataStorage/WarmupDataStorage/WarmupDataStorage';
import { FlowAPIMemoryDataStorage } from './DataStorage/FlowAPIMemoryStorage/FlowAPIMemoryDataStorage';
export class BookingsViewerStorageManager {
  constructor(flowAPI) {
    this.flowAPI = flowAPI;
    _defineProperty(this, "warmupDataStorage", void 0);
    _defineProperty(this, "flowAPIMemoryDataStorage", void 0);
    this.warmupDataStorage = new WarmupDataStorage(flowAPI);
    this.flowAPIMemoryDataStorage = new FlowAPIMemoryDataStorage(flowAPI);
  }
  get isSSR() {
    return this.flowAPI.environment.isSSR;
  }
  cacheKeyToDataStorageKey(cacheKey) {
    return cacheKey.join('-');
  }
  set(cacheKey, value, memoryStorageTTLInMinutes) {
    const key = this.cacheKeyToDataStorageKey(cacheKey);
    if (this.isSSR) {
      return this.warmupDataStorage.set(key, value);
    }
    return this.flowAPIMemoryDataStorage.set(key, value, memoryStorageTTLInMinutes);
  }
  get(cacheKey) {
    const key = this.cacheKeyToDataStorageKey(cacheKey);
    const warmupDataValue = this.warmupDataStorage.get(key);
    const memoryDataValue = this.flowAPIMemoryDataStorage.get(key);
    if (warmupDataValue && !this.isSSR && !memoryDataValue) {
      this.flowAPIMemoryDataStorage.set(key, warmupDataValue);
    }
    return warmupDataValue || memoryDataValue;
  }
}
//# sourceMappingURL=BookingsViewerStorageManager.js.map